// extracted by mini-css-extract-plugin
module.exports = {"serviceQuestionsMoreLink":"service-questions-more-link-module--serviceQuestionsMoreLink--39nQ8"};